module.exports = __webpack_public_path__ + "static/agentes-de-cambio-6d073b6c47f6609010f0c8cd03201ad9.png";